import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { ControlContainer, NgForm } from '@angular/forms';
import { Aluno } from 'src/app/core/aluno';
import { ComboPrograma } from 'src/app/core/combo-programa';
import { ComboProjeto } from 'src/app/core/combo-projeto';
import { MotivoDesligamento } from 'src/app/core/motivo-desligamento';
import { NiveisTurmas } from 'src/app/core/niveis-turmas';
import { Projeto } from 'src/app/core/projeto';
import { TiposPublicoPrioritario } from 'src/app/core/tipos-publico-prioritario';
import { Unidade } from 'src/app/core/unidade';
import { DataUtilService } from 'src/app/services/commons/data-util.service';
import { NiveisTurmasService } from 'src/app/services/niveis-turmas/niveis-turmas.service';
import { ProgramaService } from 'src/app/services/programa/programa.service';
import { ProjetoService } from 'src/app/services/projeto/projeto.service';
import { UnidadeService } from 'src/app/services/unidade/unidade.service';
import { AlunoService } from 'src/app/services/aluno/aluno.service';
import { ComboEmpresaSocial } from '../../../../core/combo-empresa-social';
import { EntidadesSociais } from '../../../../core/entidades-sociais';
import { MatriculaSecretaria } from '../../../../core/matricula-secretaria';
import { EntidadeSocialService } from '../../../../services/entidade-social/entidade-social.service';

@Component({
  selector: 'academico',
  templateUrl: './academico.component.html',
  styleUrls: ['./academico.component.css'],
  viewProviders: [{ provide: ControlContainer, useExisting: NgForm }]
})
export class AcademicoComponent implements OnInit, OnChanges {

  @Input() aluno: Aluno;
  comboEmpresaSocialSelecionado: ComboEmpresaSocial = new ComboEmpresaSocial();

  entidadesSociais: EntidadesSociais[];
  unidades: Unidade[];
  niveisTurmas: NiveisTurmas[];

  sim_nao: any[] = [
    {tipo: 'Sim', flag: 'S'},
    {tipo: 'Não', flag: 'N'}
  ];

  todosProjetos: Projeto[];
  comboProjetos: ComboProjeto[];
  comboProgramas: ComboPrograma[];

  isEditarMatricula = true;

  constructor(
    private unidadeService: UnidadeService,
    private niveisTurmasService: NiveisTurmasService,
    private projetoService: ProjetoService,
    private programaService: ProgramaService,
    private dataUtilService: DataUtilService,
    private entidadeSocialService: EntidadeSocialService,
    private alunoService: AlunoService
    ) { }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['aluno']) {
      this.sincronizarUnidade();
    }
  }

  ngOnInit() {
    this.onDataDesligamentoChange(this.aluno.dataDesligamento);
    if (!this.aluno.unidade) {
      this.aluno.unidade = new Unidade();
    }
    if (!this.aluno.entidadeSocial) {
        this.aluno.entidadeSocial = new EntidadesSociais();
    }
    if (!this.aluno.matriculaSecretaria) {
        this.aluno.matriculaSecretaria = new MatriculaSecretaria();
    }
    this.aluno.nivelTurma = new NiveisTurmas();
    this.aluno.motivoDesligamento = new MotivoDesligamento();
    this.aluno.tiposPublicoPrioritario = new TiposPublicoPrioritario();

    this.unidadeService.getAllUnidadeParaCombo().subscribe((unidades: Unidade[])=> {
      this.unidades = unidades;
      this.sincronizarUnidade();
    });

    this.entidadeSocialService.getAll().subscribe((entidadesSociais: EntidadesSociais[])=> {
      this.entidadesSociais = entidadesSociais;
      if (this.aluno?.entidadeSocial?.id) {
        this.preencherComboEmpresaSocialSelecionado(this.aluno.entidadeSocial);
      }
    });

    this.niveisTurmasService.getAll()
      .subscribe((niveisTurmas: NiveisTurmas[]) => {
        this.niveisTurmas = niveisTurmas;
    });

    this.projetoService.getAllIntituicaoLogada().subscribe((projetos: Projeto[]) => {
      this.todosProjetos    = projetos;
      this.comboProjetos    = projetos;
    });

    this.programaService.getAllCombo().subscribe((programas: ComboPrograma[]) => {
      this.comboProgramas = programas;
    });
  }

  private sincronizarUnidade() {
    if (this.aluno && this.aluno.unidade && this.unidades && this.unidades.length) {
      const unidadeCorrespondente = this.unidades.find(u => u.idUnidade === this.aluno.unidade.idUnidade);
      if (unidadeCorrespondente) {
        this.aluno.unidade = unidadeCorrespondente;
      }
    }
  }

  editarMatricula() {
    this.isEditarMatricula = !this.isEditarMatricula;
  }

  carregarMatriculaAluno() {
    if (!this.aluno?.id) {
      return;
    }

    this.alunoService.carregarMatricula(this.aluno.id)
      .subscribe(() => {
        this.aluno.matriculaAluno = `${this.aluno.id}`;
      });
  }

  carregarPrograma(programa: ComboPrograma) {
    this.aluno.projeto = null;

    if(!programa) {
      this.comboProjetos = this.todosProjetos;
      return;
    }

    this.comboProjetos   = this.todosProjetos.filter(p => p.programa && p.programa.id === programa.id).map(p => {
      let combo = new ComboProjeto();
      combo.id   = p.id;
      combo.nome = p.nome;
      return combo;
    });
  }

  carregarProjeto(projeto: ComboProjeto) {
    if(!projeto) {
      this.aluno.projeto = null;
      return;
    }
  }

  onMascaraDataInput(event) {
    return this.dataUtilService.onMascaraDataInput(event);
  }

  onValorChangePrograma(event: any) {
    this.aluno.programa = event;
  }

  onValorChangeProjeto(event: any) {
    this.aluno.projeto = event;
  }

  onValorChangeMatriculaSecretaria(event: MatriculaSecretaria) {
    this.aluno.matriculaSecretaria = event;
  }

  onValorChangeEmpresaSocial(comboEmpresa: ComboEmpresaSocial) {
    const entidadeSocialSelecionadaPeloCombo = this.entidadesSociais.find(entidadeSocial => entidadeSocial.id === comboEmpresa.idEntidadeSocial);
    this.preencherComboEmpresaSocialSelecionado(entidadeSocialSelecionadaPeloCombo);
    this.aluno.entidadeSocial = entidadeSocialSelecionadaPeloCombo;
  }

  preencherComboEmpresaSocialSelecionado(entidadeSocial: EntidadesSociais) {
    this.comboEmpresaSocialSelecionado = new ComboEmpresaSocial();
    this.comboEmpresaSocialSelecionado.id = entidadeSocial.empresa.id;
    this.comboEmpresaSocialSelecionado.nomeRazaoSocial = entidadeSocial.empresa.nomeRazaoSocial;
    this.comboEmpresaSocialSelecionado.idEntidadeSocial = entidadeSocial.id;
  }

  onDataDesligamentoChange(dataDesligamento: Date | null) {
    const hoje = new Date();
    hoje.setHours(0, 0, 0, 0);

    if (!dataDesligamento) {
      this.aluno.stAtivo = true;
    } else {
      const dataDesligamentoConstante = new Date(dataDesligamento);
      dataDesligamentoConstante.setHours(0, 0, 0, 0);
      this.aluno.stAtivo = dataDesligamentoConstante > hoje;
    }
  }

  onTipoPublicoPrioritarioChange(tipoPublicoPrioritario: any) {
    this.aluno.tiposPublicoPrioritario = tipoPublicoPrioritario;
  }

  onMotivoDesligamentoChange(motivoDesligamento: any) {
    this.aluno.motivoDesligamento = motivoDesligamento;
  }

  onTiposPublicosPrioritariosChange(tiposSelecionados: TiposPublicoPrioritario[]): void {
    this.aluno.tiposPublicosPrioritarios = tiposSelecionados || [];
  }

  onChangePublicoPrioritario(value: any): void {
    if (!value || !value.checked) {
      this.aluno.publicoPrioritario = 'não';
    } else {
      this.aluno.publicoPrioritario = 'sim';
    }
  }
}
